import linkedinCompanyBlacklistRepository from "infra/repositories/linkedincompanyblacklist-repository";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Logger } from "infra/logger/logger";
import { AxiosError } from "axios";

export const useLinkedInCompanyBlacklist = (filter?: any) => {
  const logger = Logger.getInstance();

  return useQuery({
    queryKey: ["linkedincompanyblacklist", filter],
    queryFn: async () => {
      try {
        const result = await linkedinCompanyBlacklistRepository.getAll(filter);
        return result;
      } catch (error: any) {
        if (error instanceof AxiosError) {
          logger.error(
            error.response?.data.metadata.errors[0],
            error.response?.data.metadata
          );
          throw new Error(error.response?.data.metadata.errors);
        }
        throw error;
      }
    },
    retry: Number(process.env.REACT_APP_QUERY_RETRY) || 5,
    staleTime: 5000,
  });
};

export const useCreateLinkedinCompanyBlacklistMutation = () => {
  const logger = Logger.getInstance();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (input: { companyName: string; matchType: string; lastModifiedBy: string }) => {
      const result = await linkedinCompanyBlacklistRepository.create(input);
      return result;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["linkedincompanyblacklist"] });
    },
    onError: (error: any) => {
      if (error instanceof AxiosError) {
        if (error.response?.data?.metadata?.errors) {
          const errors = error.response.data.metadata.errors;
          logger.error(errors[0], error.response?.data.metadata);
          const customError = new Error(errors[0]);
          throw customError;
        } else {
          throw new Error("Erro desconhecido da API");
        }
      } else {
        logger.error("Erro desconhecido", error);
        throw error;
      }
    },
  });
};

export const useDeleteLinkedinCompanyBlacklistMutation = () => {
  const logger = Logger.getInstance();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      if (!id) throw new Error("ID inválido para exclusão");
      const result = await linkedinCompanyBlacklistRepository.delete(id);
      return result;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["linkedincompanyblacklist"] });
    },
    onError: (error: any) => {
      if (error instanceof AxiosError) {
        logger.error(
          error.response?.data.metadata.errors[0],
          error.response?.data.metadata
        );
        throw new Error(error.response?.data.metadata.errors);
      }
      throw error;
    },
  });
};
